<!-- Footer -->
<div class="navbar navbar-sm navbar-footer-new border-top" id="footer">
    <div class="container-fluid">
        <span class="fs-13">&copy; 2025
            <a [routerLink]="['/']">{{ 'common.admicroTool' | translate }}</a>
            <span class="text-muted">{{ 'common.frontEndAdtech' | translate }}</span>
        </span>

<!--        <div class="list-product">-->
<!--            <ul class="nav">-->
<!--                <li class="nav-item ms-md-1">-->
<!--                    <a href="https://ci.admicro.vn/" target="_blank"-->
<!--                       class="navbar-nav-link navbar-nav-link-icon rounded cursor-pointer fw-light-bold">-->
<!--                        <img src="./assets/styles/default/images/creativity.png" alt="ci" height="20px" class="me-1">-->
<!--                        Content Insight-->
<!--                    </a>-->
<!--                </li>-->
<!--                <li class="nav-item ms-md-1">-->
<!--                    <a href="https://safety.admicro.vn/app/" target="_blank"-->
<!--                       class="navbar-nav-link navbar-nav-link-icon rounded cursor-pointer fw-light-bold">-->
<!--                        <img src="./assets/styles/default/images/logo-brand-safety.png" alt="brand-safety" height="20px" class="me-1">-->
<!--                        Brand safety-->
<!--                    </a>-->
<!--                </li>-->
<!--                <li class="nav-item ms-md-1">-->
<!--                    <a href="https://dmp.admicro.vn/" target="_blank"-->
<!--                       class="navbar-nav-link navbar-nav-link-icon rounded cursor-pointer fw-light-bold">-->
<!--                        <img src="./assets/styles/default/images/platform.png" alt="platform" height="20px" class="me-1">-->
<!--                        Data management platform-->
<!--                    </a>-->
<!--                </li>-->
<!--            </ul>-->
<!--        </div>-->

        <ul class="nav">
            <li class="nav-item ms-md-1">
                <a (click)="openLinkGuideDoc()" class="navbar-nav-link navbar-nav-link-icon rounded cursor-pointer">
                    <div class="d-flex align-items-center mx-md-1">
                        <i class="ph-file-text"></i>
                        <span class="d-none d-md-inline-block ms-2">{{ 'modules.user.common.guideDoc' | translate }}</span>
                    </div>
                </a>
            </li>
        </ul>
    </div>
</div>
<!-- /footer -->
